'use client';
import { memo, useMemo } from 'react';

import { BoxProps } from './Box.types';
import { BOX_COMPONENTS } from './Box.content';
import { absoluteFillProps, centerContentProps } from './Box.constants';

function Box({
  variant = 'default',
  absoluteFill,
  centerContent,
  ...rest
}: BoxProps) {
  const Component = BOX_COMPONENTS[variant];
  const extraProps = useMemo(() => {
    const props = {};

    if (absoluteFill) {
      Object.assign(props, absoluteFillProps);
    }

    if (centerContent) {
      Object.assign(props, centerContentProps);
    }

    return props;
  }, [centerContent, absoluteFill]);

  return <Component {...extraProps} {...rest} />;
}

export default memo(Box);
